import {
  RouteRedirectHandler,
  RouterParams,
} from '@kaidam/fc-shared/src/types/frontend/router'

import {
  ROLE_SCOPE_DESCENDENTS,
} from '@kaidam/fc-shared/src/constants'

import {
  RootState,
  Store,
} from '../types/store'

import {
  hasRole,
} from '@kaidam/fc-shared/src/utils/user_summary'

import projectSelectors from '../store/selectors/project'

export const getRoleRedirectHandler = ({
  redirectName,
  roleNames = [],
  roleMode = 'any',
  orgParam,
  scopeParam,
  params = {},
  getAsyncParams,
}: {
  redirectName: string,
  roleNames?: string[],
  roleMode?: 'any' | 'all',
  orgParam?: string,
  scopeParam?: string,
  params?: RouterParams,
  getAsyncParams?: {
    (store: Store): Promise<RouterParams>,
  }
}): RouteRedirectHandler<RootState> => async (store, toState) => {

  if(getAsyncParams) {
    const asyncParams = await getAsyncParams(store)
    params = Object.assign({}, params, asyncParams)
  }

  const userSummary = projectSelectors.summary(store.getState())

  if(roleNames.length > 0) {
    const matchingRoles = roleNames.filter(roleName => userSummary?.roles[roleName] ? true : false)
    const hasMatchingRoles = roleMode == 'any' ? matchingRoles.length > 0 : matchingRoles.length == roleNames.length
    if(!hasMatchingRoles) {
      console.error(`redirecting to dashboard because of missing roles ${roleNames.join(' ')}`)
      return {
        name: 'dashboard',
        params: {},
      }
    }
  }

  const newParams: RouterParams = Object.keys(params).reduce((all, name) => {
    if(toState.params[name] != params[name]) {
      all[name] = params[name]
    }
    return all
  }, {})

  if (orgParam && !toState.params[orgParam]) {
    newParams[orgParam] = userSummary?.org
  }

  if (scopeParam && !toState.params[scopeParam]) {
    newParams[scopeParam] = ROLE_SCOPE_DESCENDENTS
  }

  if (toState.name != redirectName || Object.keys(newParams).length > 0) {
    return {
      name: redirectName,
      params: newParams,
    }
  }
  else {
    return null
  }
}

export const rbacRedirectHandler: RouteRedirectHandler<RootState> = async (store, toState) => {
  const userSummary = projectSelectors.summary(store.getState())
  const hasOrgViewer = hasRole(userSummary, 'rbac:org_viewer')
  const hasUserViewer = hasRole(userSummary, 'rbac:user_viewer')
  const hasEventViewer = hasRole(userSummary, 'rbac:event_viewer')
  const hasProfileViewer = hasRole(userSummary, 'rbac:org_viewer')
  const hasProfileEditor = hasRole(userSummary, 'rbac:org_editor')
  const hasRbacAdmin = hasRole(userSummary, 'rbac:admin')

  // they have no role
  if(!hasOrgViewer && !hasUserViewer && !hasProfileViewer && !hasProfileEditor) {
    return {
      name: 'dashboard',
      params: {},
    }
  }
  // we have org viewer so let's view the overview
  else 
  
  if(hasOrgViewer) {
    return {
      name: 'rbac.profiles.all',
      params: {},
    }
  }
  // cannot see org overview
  else {
    // can see network profiles
    if(hasProfileViewer) {
      return {
        name: 'rbac.profiles.all',
        params: {},
      }
    }
    // can edit own profile
    else if(hasProfileEditor && userSummary?.org) {
      return {
        name: 'rbac.profiles.edit',
        params: {
          orgid: userSummary.org,
        },
      }
    }
    // can view users
    else if(hasUserViewer) {
      return {
        name: 'rbac.editor',
        params: {},
      }
    }
    // can do nothing
    else {
      return {
        name: 'dashboard',
        params: {},
      }
    }
  }
}
